import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import {MaterialReactTable} from 'material-react-table';
import {
  MenuItem,
} from '@mui/material';
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from '../Global';
const StockInventoryGroupByDateLocation = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
   const [permission, setPermission] = useState({});
   const [stockheading, setStockheading] = useState({});
 

  useEffect(() => {
        setPermission(FindModuleById(161)); 
console.log(permission);

    axios
      .get(`/stock-inventories/listing-groupby-date-location-detail/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setData(response.data.data.Stocks);
        setStockheading(response.data.data.Stocks_heading);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  
  const columns =[
   
    {
      header: 'Location',
      accessorFn: (row) => `${(row.location_name)?row.location_name:""} `,
    },  

    {
      accessorKey: 'date', //normal accessorKey
      header: 'Date',
    },
   
    {
      header: 'Consumable',
      accessorFn: (row) => `${(row.consumable_product)?row.consumable_product.consumable_name:""} `,
    },  
    
    {
      accessorKey: 'quantity',
      header: 'Quantity',
    },
    {
      accessorKey: 'note',
      header: 'Note',
    },
  
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   ];
   const editItem = (item)=>{
    window.location.href = "/stock-inventories-edit/"+item;
  }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Stock Inventories: {stockheading.location_detail?.title} ({stockheading.date})</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/stock-inventories">Stock Inventories</Link>
                    </li>
                    <li className="breadcrumb-item active">Stock Inventories: {stockheading.location_detail?.title} ({stockheading.date})</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Stock Inventories: {stockheading.location_detail?.title} ({stockheading.date}) </h4>
                    <div className="table-responsive">
                    <MaterialReactTable columns={columns} data={data} 
                            enableColumnOrdering
                            enablePinning
                            enableRowActions
                            renderColumnActionsMenuItems 
                            renderRowActionMenuItems={({ row }) => [
                              <MenuItem key="edit" onClick={() => editItem(row.original.stock_inventory_id)}>
                                Edit
                              </MenuItem>,
                            //   <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                            //   View
                            // </MenuItem>,
                            // <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                            //     Delete
                            //   </MenuItem>,
                            ]}
                          />
                        </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StockInventoryGroupByDateLocation;
